<template>
    <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormatted" readonly
              v-bind="attrs" :hint="filterValue" persistent-himnt
              @blur="date = parseDate(dateFormatted)"
              v-on="on"
              :label="st(config.label)"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filterValue"
            no-title range scrollable
          >          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="filterValue=null;"
          >
          {{$t('wkt.admin.common.dialog-buttons.delete')}}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="handleInputChange"
          >
            {{$t('wkt.admin.common.dialog-buttons.ok')}}
          </v-btn></v-date-picker>
        </v-menu>
</template>
 
 <script> 

import BaseModule from '../../../common/BaseModule.js'

 export default {
   name: 'DateFilter',
   props: ['config','context'],
   mixins: [BaseModule],
   components: { 
   },
   // eslint-disable-next-line no-unused-vars
   data: vm => ({
      filterValue: null,
      dateFormatted: null,
      menu1: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },


    mounted() {
    },
    
    watch: {
      context: function() { 
        if (!this.context.filters || this.context.filters.length === 0) {
          this.filterValue = null;
          this.lastEvent = this.filterValue;
          return;
        }
        var filter = this.context.filters.find(f => f.type === 'date');
        if (filter) {
          this.filterValue = filter.value;
          this.lastEvent = this.filterValue;
        }
      },
      // eslint-disable-next-line no-unused-vars
      filterValue (val) {
        this.dateFormatted = this.formatDate(this.filterValue)
      },
    },
    destroyed() { 
    },
    methods: {
        getTimeFromDateArray(dateArray) {
              if (!dateArray) {
                return null;
              }

              let formattedArray = [];
              for (let pos=0; pos<dateArray.length;pos++)
              {
                  formattedArray.push(new Date(dateArray[pos] + ' ' + (pos==0?'00:00:00':'23:59:59')).toISOString());
              }
              return formattedArray;

        },
        getValue() {
            let formattedArray = this.getTimeFromDateArray(this.filterValue);
            return formattedArray?formattedArray.join():null;
        },
        emitFilterValue() {
            this.$emit('change',this.getValue());
        },
        handleInputChange() {
            this.$refs.menu1.save(this.filterValue);
            this.emitFilterValue();
        },
        formatDate (date) {
            if (!date) return null;

            if (date.length) {
                return this.formatShortDate(date[0]) + ' - ' + this.formatShortDate(date[1]);
            }
            return this.formatShortDate(date);
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
    }
 };
 </script>
  